import React, { useState, useEffect, useRef } from 'react';
import './FloatingError.scss';

const FloatingError = () => {
  const [error, setError] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Set up global error handler
    const showError = (errorObject) => {
      if (errorObject?.hebMessage) {
        setError(errorObject.hebMessage);
        setIsVisible(true);
        
        // Clear existing timeout if any
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        
        // Auto-close after 5 seconds
        timeoutRef.current = setTimeout(() => {
          handleClose();
        }, 5000);
      }
    };

    // Attach to window for axios interceptor to use
    window.showFloatingError = showError;

    return () => {
      // Cleanup
      delete window.showFloatingError;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setTimeout(() => setError(null), 300); // Wait for fade out animation
  };

  if (!error || !isVisible) {
    return null;
  }

  return (
    <div className="floating-error-overlay">
      <div className="floating-error">
        <button
          className="floating-error__close"
          onClick={handleClose}
          aria-label="Close error"
        >
          ×
        </button>
        <div className="floating-error__message">
          {error}
        </div>
      </div>
    </div>
  );
};

export default FloatingError;